import React from "react";
import { motion } from "framer-motion";

const Intro = ({ setLoading }) => {
  return (
    <div className=" bg-bg1 relative flex-col h-screen  w-screen flex">
      <motion.div
        style={{ height: "50vh" }}
        initial={{ y: "0%" }}
        animate={{ y: "-100%" }}
        transition={{ duration: 0.8, ease: "easeInOut", delay: 1.3 }}
        onAnimationComplete={() => setLoading(false)}
        className="bg-black absolute top-0 flex  index-1  w-screen"
      >
        <motion.div
          animate={{ y: 20, opacity: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="tracking-widest text-lg absolute bottom-0 font-prime  text-center w-full  text-white"
        >
          Jan Durcak
        </motion.div>
      </motion.div>
      <motion.div
        style={{ height: "50vh" }}
        initial={{ y: "0%" }}
        animate={{ y: "100%" }}
        transition={{ duration: 0.8, ease: "easeInOut", delay: 1.3 }}
        className="bg-black absolute bottom-0 flex   index-1  w-screen"
      ></motion.div>
    </div>
  );
};

export default Intro;
